import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DepartmentRequest {
  companyId?: string;
  departmentId: number;
  name: string;
  glCodes: number[];
  members: number[];
}

const useUpdateDepartmentApi = () => {
  const call = useCallback(async (params: DepartmentRequest = {} as DepartmentRequest) => {
    try {
      const { companyId, departmentId, ...rest } = params;
      const res = await axiosInstance.put<DepartmentRequest[]>(
        api.updateDepartment(departmentId, companyId),
        rest
      );

      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { execute } = useAsync(call, false);

  return {
    updateDepartments: execute,
  };
};

export default useUpdateDepartmentApi;
